import { connect } from 'react-redux';

import SummaryLeadFormUI from './SummaryLeadFormUI';
import { Selectors } from '../../../store/selectors';
import { IConfigLeadform } from '../../../types/IConfigLeadform';
import { dispatchAnalyticsAction } from '../../../store/actionCreators';
import { ISummaryLeadFormStateProps, ISummaryLeadFormDispatchProps } from './SummaryLeadFormUI';

export interface ISummaryLeadFormProps {
    selector: Selectors;
    config: IConfigLeadform;
}

const mapStateToProps = (state: any, ownProps: ISummaryLeadFormProps): ISummaryLeadFormStateProps => {
    const paymentSelectors = ownProps.selector.additionalSelectors.paymentSelectors;
    const offerSelectors = ownProps.selector.additionalSelectors.offerSelectors;
    const offerInfoSelectors = ownProps.selector.additionalSelectors.offerInfoSelectors;
    const termsSelectors = ownProps.selector.additionalSelectors.termsSelectors;
    const leadFormInfoSelectors = ownProps.selector.additionalSelectors.leadFormInfoSelectors;
    const dealerSelectors = ownProps.selector.additionalSelectors.dealerSelectors;
    const TaxTypes = dealerSelectors.getApplyTaxesAndFeesOptions();

    const zipHeaderVerbageMapper = {
        [TaxTypes.INCLUDE_ONLY_TAXES]: 'Calculate taxes for this vehicle.',
        [TaxTypes.INCLUDE_TAXES_AND_FEES]: 'Calculate taxes and fees for this vehicle.',
        [TaxTypes.EXCLUDE_TAXES_AND_FEES]: 'Update your location'
    };

    const testDriveConfigurationOption = dealerSelectors.getApplyTaxesAndFeesNewOptions(state);

    const isError = paymentSelectors.getIsError(state);
    const successfulZipCode = paymentSelectors.getLastSuccessfulZipCode(state);
    const hasEnteredSuccessfulZipCode = successfulZipCode !== '';
    const failedZipCode = paymentSelectors.getLastFailedZipCode(state);
    const offerType = offerSelectors.getCurrentOfferType(state);
    const payment = offerType !== 'cash' ? offerSelectors.getMonthlyPaymentRoundedByOfferType(state, offerType) : 0;
    const isPaymentInvalid = ownProps.config.utils.isPaymentInvalid(payment, offerType) || isError;
    const showErrorMessage = (isPaymentInvalid && offerType !== 'cash') || (failedZipCode && isError);
    const shopper = offerSelectors.getShopperInfo(state);
    const zipHeader = zipHeaderVerbageMapper[testDriveConfigurationOption] || 'Update your location to calculate taxes & fees';
    const taxesAndFees =
        offerType === 'cash' ? termsSelectors.getTaxesAndFeesForCashOffer(state) : termsSelectors.getTaxesAndFees(state);
    const taxesAndFeesWithoutUpfront =
        offerType === 'cash'
            ? termsSelectors.getTaxesAndFeesForCashOffer(state)
            : termsSelectors.getTaxesAndFeesWithoutUpfrontTax(state);
    let errorMessage = failedZipCode ? `Looks like we are having trouble calculating a payment for ${failedZipCode}. ` : '';

    if (errorMessage) {
        errorMessage += hasEnteredSuccessfulZipCode
            ? "We've kept your previously successful payment."
            : 'Try entering your ZIP again or continue without updating taxes & fees.';
    }
    const offerHasBeenSent = offerInfoSelectors.getHasBeenSent(state);
    const shopperName = shopper.firstName;
    const leadFormConstants = leadFormInfoSelectors.getSummaryLeadFormConstants(state);

    return {
        failedZipCode,
        successfulZipCode,
        hasEnteredSuccessfulZipCode,
        taxesAndFees,
        taxesAndFeesWithoutUpfront,
        isError,
        leadFormConstants,
        isPaymentInvalid,
        showErrorMessage,
        errorMessage,
        zipHeader,
        offerHasBeenSent,
        shopperName,
        config: ownProps.config,
        selector: ownProps.selector
    };
};

const mapDispatchToProps = (dispatch: any): ISummaryLeadFormDispatchProps => {
    return {
        dispatchAnalytics: (type, description) => {
            dispatch(dispatchAnalyticsAction(type, description));
        }
    };
};

const SummaryLeadForm = connect(mapStateToProps, mapDispatchToProps)(SummaryLeadFormUI);

export default SummaryLeadForm;
